<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Dashboard
          </h1>
        </div>
        <div class="flex gap-2">
          <button
            class="bg-primary border flex gap-2 text-white hover:bg-primary/80 dark:border-gray-700 rounded py-3 px-5"
             @click="launchFaceRegister"
          >
            <span class="icon text-2xl"></span>
            <span class="text">Add Faces</span>
          </button>
        </div>
      </div>
    </div>

    <!-- grid wrapper card -->
    <div
      class="wrapper-card grid lg:grid-cols-4 grid-cols-1 md:grid-cols-2 gap-2 mt-5"
    >
      <!-- card  -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-orange-200 rounded-full w-14 h-14 text-lg p-3 text-orange-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M10 16V8a2 2 0 0 1 2-2h9V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-1h-9a2 2 0 0 1-2-2zm3-8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h9V8h-9zm3 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            {{ totalDetections }}
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">Total Detections Today
          </h2>
        </div>
      </div>
      <!-- end card -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-green-200 rounded-full w-14 h-14 text-lg p-3 text-green-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M5 22h14a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3v-.777c0-2.609-1.903-4.945-4.5-5.198A5.005 5.005 0 0 0 7 7v1H4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm12-12v2h-2v-2h2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-2 3h2v2H7v-2z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
           0
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">Late Arrivals
          </h2>
        </div>
      </div>
      <!-- end card -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-red-200 rounded-full w-14 h-14 text-lg p-3 text-red-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 32 32"
              >
                <path
                  fill="none"
                  d="M8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0ZM20.5 12.5A4.5 4.5 0 1 1 16 8a4.5 4.5 0 0 1 4.5 4.5Z"
                />
                <path
                  fill="currentColor"
                  d="M26.749 24.93A13.99 13.99 0 1 0 2 16a13.899 13.899 0 0 0 3.251 8.93l-.02.017c.07.084.15.156.222.239c.09.103.187.2.28.3c.28.304.568.596.87.87c.092.084.187.162.28.242c.32.276.649.538.99.782c.044.03.084.069.128.1v-.012a13.901 13.901 0 0 0 16 0v.012c.044-.031.083-.07.128-.1c.34-.245.67-.506.99-.782c.093-.08.188-.159.28-.242c.302-.275.59-.566.87-.87c.093-.1.189-.197.28-.3c.071-.083.152-.155.222-.24ZM16 8a4.5 4.5 0 1 1-4.5 4.5A4.5 4.5 0 0 1 16 8ZM8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0Z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            0
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">
            Unauthorized Access
          </h2>
        </div>
      </div>
      <!-- end card -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700 flex"
      >
        <div class="p-2 max-w-sm">
          <div
            class="bg-purple-200 rounded-full w-14 h-14 text-lg p-3 text-purple-600 mx-auto"
          >
            <span class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 16 16"
              >
                <g fill="currentColor">
                  <path d="M15 13v1H1.5l-.5-.5V0h1v13h13Z" />
                  <path
                    d="M13 3.207L7.854 8.354h-.708L5.5 6.707l-3.646 3.647l-.708-.708l4-4h.708L7.5 7.293l5.146-5.147h.707l2 2l-.707.708L13 3.207Z"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>

        <div class="block p-2 w-full">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
           1  Areas
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-1">Areas Monitored
          </h2>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end wrapper card -->
    <div class="mt-2 lg:flex block lg:gap-2 relative">
      <!-- <div
      class="bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 overflow-hidden"
    >
      <h1 class="text-center text-lg font-semibold mb-2"></h1>
      <img 
        alt="Live camera feed 1 showing factory floor"
        class="rounded-md w-full h-[400px] object-cover"
        src="https://storage.googleapis.com/a1aa/image/L5CJsEIuZXHWOuKsfPdJ28KQUQkEUwcWzGQgsAqJJGU.jpg"
      />
    </div>     -->

    <div
  class="bg-white dark:bg-gray-800 p-0 lg:w-3/4 w-full rounded-md box-border border dark:border-gray-700 overflow-hidden"
>
  <h1 class="text-center text-lg font-semibold mb-2"></h1>
  <img 
  src="http://127.0.0.1:5000/video_feed"
  class="rounded-md w-full h-[400px] object-cover"
  alt="Live detection feed"
/>
  <!-- <video 
    class="rounded-md w-full h-[400px] object-cover"
    controls
    autoplay
    loop
    muted
  >
    <source src="/attendance.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>  -->

</div>
      <div
        class="bg-white dark:bg-gray-800 p-5 lg:mt-0 mt-4 lg:w-2/4 border dark:border-gray-700 rounded-md w-full"
      >
        <div class="">
          <h2 class="text-lg font-semibold dark:text-gray-200">
            Live Alerts
          </h2>
        </div>
        <perfect-scrollbar class="divide-y h-96 mt-5 dark:divide-gray-700">
          <div v-for="log in attendanceLogs" :key="log.id" class="p-3 w-full">
            <div
              class="p-4 rounded-lg cursor-pointer"
              :class="{
                'bg-green-100': log.status === 'Checked In',
                'bg-red-100': log.status === 'Checked Out' || log.status === 'Unauthorized',
                'bg-yellow-100': log.status === 'Late'
              }"
            >
              <div class="text-sm">
                {{ generateAlertMessage(log) }}
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
    <!-- <div class="mt-2 lg:flex block lg:gap-2">
      <div
        class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700"
      >
        <div class="head p-5">
          <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            1,780
          </h2>
          <p class="text-gray-400 font-lexend font-normal">
            New products this week
          </p>
          <span class="float-right">
            <h2 class="text-green-500 -mt-12 flex">
              <span class="mr-2"> 27.9% </span
              ><span>
                <Icon icon="akar-icons:arrow-up" />
              </span>
            </h2>
          </span>
        </div>
        <div class="wrapper-chart mt-5 pr-2 pl-2">
          <apexchart
            width="100%"
            height="380"
            type="bar"
            :options="optionsBar"
            :series="seriesBar"
          ></apexchart>
          <br />
          <hr />
          <div class="footer p-5">
            <div class="wrapper-button flex justify-between mt-3">
              <select
                name=""
                id=""
                class="dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 border max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
              >
                <option value="">Last 7 days</option>
              </select>
              <button class="uppercase border-b border-red-600 text-red-600">
                Product Report
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700"
      >
        <div class="head p-5">
          <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            5,355
          </h2>
          <p class="text-gray-400 font-lexend font-normal">Visitor this week</p>

          <span class="float-right">
            <h2 class="text-green-500 -mt-12 flex">
              <span class="mr-2"> 47.9% </span
              ><span>
                <Icon icon="akar-icons:arrow-up" />
              </span>
            </h2>
          </span>
        </div>
        <div class="wrapper-chart mt-5">
          <apexchart
            width="100%"
            height="380"
            type="area"
            :options="optionsVisitor"
            :series="seriesVisitor"
          ></apexchart>
          <br />
          <hr />
          <div class="footer p-5">
            <div class="wrapper-button flex justify-between mt-3">
              <select
                name=""
                id=""
                class="dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 border max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
              >
                <option value="">Last 7 days</option>
              </select>
              <button class="uppercase border-b border-red-600 text-red-600">
                Vistor Report
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700"
      >
        <div class="head p-5">
          <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
            475
          </h2>
          <p class="text-gray-400 font-lexend font-normal">
            User signups this week
          </p>
        </div>

        <div class="wrapper-chart mt-5">
          <apexchart
            width="100%"
            height="380"
            type="pie"
            :options="optionsDonut"
            :series="seriesDonut"
          ></apexchart>
          <div class="p-3"></div>
          <br />
          <hr />
          <div class="footer p-5">
            <div class="wrapper-button flex justify-between mt-3">
              <select
                name=""
                id=""
                class="dark:bg-gray-800 dark:hover:bg-gray-700 border dark:border-gray-700 max-w-lg px-4 py-3 block rounded-md text-gray-500 dark:text-gray-400"
              >
                <option value="">Last 7 years</option>
              </select>

              <button class="uppercase border-b border-red-600 text-red-600">
                User Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> -->



<!--  -->

<div class="mt-2 lg:flex block lg:gap-2">
  <!-- Total Attendance Today -->
  <div class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700">
    <div class="head p-5">
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">{{ totalDetections }}</h2>
      <p class="text-gray-400 font-lexend font-normal">Total Detections Today</p>
      <span class="float-right">
        <h2 class="text-green-500 -mt-12 flex">
          <span class="mr-2"> +12% </span>
          <span><Icon icon="akar-icons:arrow-up" /></span>
        </h2>
      </span>
    </div>
    <div class="wrapper-chart mt-5 pr-2 pl-2">
      <apexchart width="100%" height="380" type="bar" :options="optionsBar" :series="seriesBar"></apexchart>
    </div>
  </div>
  
  <!-- Compliance Percentage -->
  <div class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700">
    <div class="head p-5">
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">{{ compliancePercentage }}%</h2>
      <p class="text-gray-400 font-lexend font-normal">Compliance Percentage</p>
    </div>
    <div class="wrapper-chart mt-5">
      <apexchart width="100%" height="380" type="area" :options="optionsArea" :series="seriesArea"></apexchart>
    </div>
  </div>
  
  <!-- Violations Breakdown -->
  <div class="mt-2 bg-white dark:bg-gray-800 p-0 w-full rounded-md box-border border dark:border-gray-700">
    <div class="head p-5">
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">{{ totalViolations }}</h2>
      <p class="text-gray-400 font-lexend font-normal">Total Violations</p>
    </div>
    <div class="wrapper-chart mt-5">
      <apexchart width="100%" height="380" type="pie" :options="optionsPie" :series="seriesPie"></apexchart>
    </div>
  </div>
</div>
    <!--  -->

    
    <div class="mt-5 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <p class="uppercase text-xs text-gray-700 font-semibold">overview</p>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Violation Logs

          </h1>
        </div>
        <div class="flex gap-2">
          <button
            class="bg-primary border flex gap-2 text-white hover:bg-primary/80 dark:border-gray-700 rounded py-3 px-5"
             @click="exportToPDF"
          >
            <span class="icon text-2xl"></span>
            <span class="text">Export Report</span>
          </button>
        </div>
      </div>
    </div>
    <div class="wrapping-table mt-10">
      <!-- <button @click="exportToPDF" class="mb-4 px-4 py-2 bg-blue-500 text-white rounded">Export as PDF</button> -->
      <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll border border-gray-300 dark:border-gray-600 shadow-md rounded-lg">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400 border-b border-gray-300 dark:border-gray-600">
          <tr>
            <th scope="col" class="uppercase px-6 py-3 border-r">Employee ID</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Employee Name</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Status</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Date & Time</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Location</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Check-in Device</th>
            <th scope="col" class="uppercase px-6 py-3 border-r">Duration</th>
            <th scope="col" class="uppercase px-6 py-3">Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-700" v-for="log in attendanceLogs" :key="log.id">
            <td class="px-6 py-4 border-r">{{ formatEmployeeId(log.id) }}</td>
            <td class="px-6 py-4 border-r">{{ log.employee }}</td>
            <td class="px-6 py-4 border-r">
              <span class="px-3 py-1 rounded-md" 
                :class="{
                  'text-green-800 bg-green-300': log.status === 'Checked In',
                  'text-red-800 bg-red-300': log.status === 'Checked Out',
                  'text-yellow-800 bg-yellow-300': log.status === 'Late',
                }">
                {{ log.status }}
              </span>
            </td>
            <td class="px-6 py-4 border-r">{{ log.datetime }}</td>
            <td class="px-6 py-4 border-r">{{ log.location }}</td>
            <td class="px-6 py-4 border-r">{{ log.device }}</td>
            <td class="px-6 py-4 border-r">{{ log.duration }}</td>
            <td class="px-6 py-4">{{ log.remarks }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { useDashboardStore } from '../store/dashboardStore';
import { Icon } from "@iconify/vue";
import Alert from "@/components/Alert.vue";
import jsPDF from "jspdf";
import axios from 'axios';
import "jspdf-autotable";

export default {
  name: "Dashboard",
  data() {
    return {
      store: useDashboardStore(),
      optionsBar: {
        chart: { type: 'bar' },
        xaxis: { categories: [], title: { text: 'Employees' } },
        yaxis: { title: { text: 'Detections' } },
      },
      seriesBar: [],

      optionsArea: {
        chart: { type: 'area' },
        xaxis: { categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'], title: { text: 'Weeks' } },
        yaxis: { title: { text: 'Compliance Percentage' } },
      },
      seriesArea: [{ name: 'Compliance', data: [25, 45, 55, 39] }],

      optionsPie: {
        labels: ['Checked In', 'Late', 'Unauthorized', 'Checked Out'],
      },
      seriesPie: [],
    };
  },
  computed: {
    totalDetections() {
      return this.store.totalDetections;
    },
    compliancePercentage() {
      return this.store.compliancePercentage;
    },
    totalViolations() {
      return this.store.totalViolations;
    },
    attendanceLogs() {
      return this.store.attendanceLogs;
    }
  },
  mounted() {
    this.fetchStatsAndData();
    setInterval(this.fetchStatsAndData, 3000);
    this.updateCharts();
    setInterval(this.updateCharts, 3000);
  },
  methods: {
    async fetchStatsAndData() {
      try {
        const res = await fetch("http://127.0.0.1:5000/get_dashboard_data");
        const data = await res.json();
        this.store.setDashboardData(data);
      } catch (err) {
        console.error("Failed to fetch dashboard data:", err);
      }
    },

    updateCharts() {
      const logs = this.store.attendanceLogs;
      const nameCount = {};
      const statusCount = { 'Checked In': 0, 'Late': 0, 'Unauthorized': 0, 'Checked Out': 0 };

      logs.forEach(log => {
        nameCount[log.employee] = (nameCount[log.employee] || 0) + 1;
        if (statusCount.hasOwnProperty(log.status)) {
          statusCount[log.status]++;
        }
      });

      this.optionsBar.xaxis.categories = Object.keys(nameCount);
      this.seriesBar = [{ name: 'Detections', data: Object.values(nameCount) }];

      this.seriesPie = [
        statusCount['Checked In'],
        statusCount['Late'],
        statusCount['Unauthorized'],
        statusCount['Checked Out']
      ];
    },

    formatEmployeeId(id) {
      return id.toString().padStart(4, '0');
    },

    generateAlertMessage(log) {
      const time = this.formatTime(log.datetime);

      if (log.status === "Checked In") {
        return `${log.employee} checked in at ${time}`;
      } else if (log.status === "Checked Out") {
        return `${log.employee} checked out at ${time}`;
      } else if (log.status === "Late") {
        return `${log.employee} is late (${time})`;
      } else if (log.status === "Unauthorized") {
        return `${log.employee} attempted unauthorized access`;
      } else {
        return `${log.employee} - ${log.status}`;
      }
    },

    formatTime(datetime) {
      if (!datetime) return "";
      const dateObj = new Date(datetime);
      return dateObj.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    },
    async launchFaceRegister() {
    try {
      const res = await fetch("http://127.0.0.1:5000/start_face_register");
      const data = await res.json();
      if (data.status === 'success') {
        alert("Face Register window is opening...");
      } else {
        alert("Failed to launch face register: " + data.message);
      }
    } catch (err) {
      alert("API error: " + err.message);
    }
  },

    exportToPDF() {
      const doc = new jsPDF();
      const brandName = "Logic Clutch Software LLP";
      const reportTitle = "Attendance Report";
      const logoPath = "/lc_logo.png";

      const img = new Image();
      img.src = logoPath;
      img.onload = () => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addImage(img, "PNG", 10, 10, 30, 30);
        doc.setFont("times", "bold");
        doc.setFontSize(16);
        doc.text(brandName, 45, 25);

        doc.setFontSize(22);
        doc.setTextColor(40, 40, 40);
        doc.text(reportTitle, 10, 50);

        doc.setLineWidth(0.5);
        doc.line(10, 55, 200, 55);

        doc.setGState(new doc.GState({ opacity: 0.15 }));
        doc.addImage(img, "PNG", pageWidth / 4, pageHeight / 4, 100, 100, '', 'FAST');
        doc.setGState(new doc.GState({ opacity: 1 }));

        const tableStartY = 65;
        const tableColumn = ["Emp ID", "Emp Name", "Remarks", "Check-in Device", "Location"];
        const tableRows = this.store.attendanceLogs.map(log => [
          this.formatEmployeeId(log.id),
          log.employee,
          log.remarks,
          log.device,
          log.location
        ]);

        let y = tableStartY;

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setFillColor(50, 50, 150);
        doc.setTextColor(255, 255, 255);
        doc.rect(10, y - 5, 190, 8, "F");

        tableColumn.forEach((col, index) => {
          doc.text(col, 15 + index * 40, y);
        });

        y += 10;

        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        tableRows.forEach((row, rowIndex) => {
          doc.setFillColor(rowIndex % 2 === 0 ? 245 : 230, 230, 230);
          doc.setTextColor(0, 0, 0);
          doc.rect(10, y - 5, 190, 8, "F");

          row.forEach((cell, index) => {
            doc.text(String(cell), 15 + index * 40, y);
          });

          y += 10;
        });

        doc.setLineWidth(0.5);
        doc.line(10, y + 5, 200, y + 5);

        doc.save("Attendance_Report.pdf");
      };

      img.onerror = () => {
        console.error("Error loading the logo image. Make sure it's in the public folder.");
      };
    }
  }
};
</script>
